<template>
    <crud-facecade
        :url="url"
        :columns="columnList"
        :buttons="buttons"
        v-wechat-title="title"
        :addButton="{ permission: 'permission:create' }"
        :deleteButton="{ enabled: true, permission: 'permission:delete' }"
        :updateButton="{ permission: 'permission:update' }"
    >
    </crud-facecade>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `MessageGroup`,
    props: {

    },
    data() {
        return {
            title: `消息组`,
            messageList: [],
            url: { baseURL: `/api/AcisSystem/MessageGroup`,
                get: () => {
                    return new Promise((resolve, reject) => {
                        let req = this.myaxios.get(`/api/AcisSystem/MessageGroup/Get`)
                        req.then(data => {
                            data = _.map(data, d => {
                                return {
                                    id: d.id,
                                    name: d.name,
                                    ac_sys_user_id: d.ac_sys_user_id
                                }
                            })
                            resolve(data)
                        }).catch(e => reject(e))
                    })
                } },
            buttons: [],
            users: []
        }
    },
    created() {
        this.loadUsers()
    },
    computed: {
        ...mapGetters([`hospital_ward_auth`]),
        columnList() {
            return [{
                type: `string`,
                prop: `id`,
                label: `编号`,
                isListable: false,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                isKey: true
            }, {
                type: `string`,
                prop: `name`,
                label: `组名称`,
                isListable: true,
                width: `180`,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `multiselect`,
                prop: `ac_sys_user_id`,
                label: `分组用户`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                config: {
                    collapseTags: false
                },
                // searchable: true,
                options: this.users,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }]
        }
    },
    mounted() {

    },
    methods: {
        loadUsers() {
            let req = this.myaxios.get(`/api/AcisSystem/SysUser/Get`)
            req.then((data) => {
                this.users = _.map(data, d => {
                    return {
                        value: d.id,
                        label: d.dic_worker_name || `--`,
                        code: d.username,
                        disabled: d.is_deleted
                    }
                })
            }).catch(e => {
                console.log(e)
            })
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Message/MessageGroup.vue